import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ICON_GRIP } from '../lib/icons'
import { timeAgo } from '../lib/time'
import type { ProjectDto } from '../lib/types'

interface ProjectCardProps {
  project: ProjectDto
  groupUuid: string
  onDragStart: (e: React.DragEvent, project: ProjectDto, groupUuid: string) => void
  onDragEnd: (e: React.DragEvent) => void
  onDragOver: (e: React.DragEvent, project: ProjectDto, groupUuid: string) => void
  onDragLeave: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent, project: ProjectDto, groupUuid: string) => void
}

export function ProjectCard({
  project: p, groupUuid,
  onDragStart, onDragEnd, onDragOver, onDragLeave, onDrop,
}: ProjectCardProps) {
  const [keyCopied, setKeyCopied] = useState(false)

  const copyKey = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(p.projectKey)
      setKeyCopied(true)
      setTimeout(() => setKeyCopied(false), 800)
    } catch { /* ignore */ }
  }

  return (
    <div
      className="card project-card"
      data-project-uuid={p.uuid}
      data-source-group-uuid={groupUuid}
      onDragOver={(e) => onDragOver(e, p, groupUuid)}
      onDragLeave={onDragLeave}
      onDrop={(e) => onDrop(e, p, groupUuid)}
    >
      <Link to={`/projects/${encodeURIComponent(p.projectKey)}`} className="project-card-link" draggable={false}>
        <div className="project-card-body">
          <h4 className="project-card-title">{p.name}</h4>
          <p className="project-card-desc">{p.description || 'No description'}</p>
        </div>
        <div className="project-card-meta">
          <span
            className={`project-card-key${keyCopied ? ' copied' : ''}`}
            title="Click to copy"
            onClick={copyKey}
          >
            {keyCopied ? 'Copied!' : p.projectKey}
          </span>
          <span className="project-card-time">{timeAgo(p.updatedAt)}</span>
        </div>
      </Link>

      <button
        type="button"
        className="project-drag-handle"
        title="Drag to reorder"
        aria-label="Drag to reorder"
        draggable
        onDragStart={(e) => onDragStart(e, p, groupUuid)}
        onDragEnd={onDragEnd}
        onClick={(e) => { e.preventDefault(); e.stopPropagation() }}
        dangerouslySetInnerHTML={{ __html: ICON_GRIP }}
      />
    </div>
  )
}
